import React from "react";
import { motion } from "framer-motion";
import { MenuItem } from "./MenuItem";

// Animation variants for the navigation container
const navigationVariants = {
  open: {
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.15,
    },
  },
  closed: {
    transition: {
      staggerChildren: 0.05,
      staggerDirection: -1,
    },
  },
};

// Navigation component with premium styling
export const Navigation = ({ menuItems, onClose }) => (
  <motion.nav
    variants={navigationVariants}
    className="px-4 py-2"
  >
    {/* Section Label */}
    <motion.div
      variants={{
        open: { opacity: 1, y: 0 },
        closed: { opacity: 0, y: -10 },
      }}
      className="px-4 mb-3"
    >
      <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">
        Menu
      </span>
    </motion.div>

    {/* Menu Items */}
    <motion.ul className="space-y-1">
      {menuItems.map((item, index) => (
        <MenuItem key={index} item={item} onClose={onClose} />
      ))}
    </motion.ul>
  </motion.nav>
);

export default Navigation;
